import React from 'react';
import { formatAmount } from '../helpers/formatingHelpers';
import PropTypes from 'prop-types';
import LocaleText from './LocaleText';
import Isvg from 'react-inlinesvg';

class FormControl extends React.Component {
    constructor(props) {
        super(props);
        this.DEFAULT_AMOUNT_MAX = 9999999;
        this.DEFAULT_AMOUNT_MIN = this.props.min;
        this.DEFAULT_AMOUNT_STEP = 50;

        let isEmpty = true;
        let textareaValue = '';

        if (props.value && `${props.value}` !== '') {
            isEmpty = false;
            textareaValue = props.value;
        }

        if (props.defaultValue && `${props.defaultValue}` !== '') {
            textareaValue = props.defaultValue;
        }

        this.amountMin = this.props.min || this.DEFAULT_AMOUNT_MIN;
        this.amountMax = this.DEFAULT_AMOUNT_MAX;
        const amount = this.props.value || this.props.defaultValue || this.amountMin;

        this.state = {
            isEmpty: isEmpty,
            isSelected: false,
            textareaValue: textareaValue,
            amount: amount * 1,
            amountFormated: formatAmount(amount),
            error: false,
        };

        this.onChangeInput = this.onChangeInput.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onChangeAmount = this.onChangeAmount.bind(this);
        this.onBlurAmount = this.onBlurAmount.bind(this);
        this.onDecreaseAmount = this.onDecreaseAmount.bind(this);
        this.onIncreaseAmount = this.onIncreaseAmount.bind(this);
    }

    getValue() {
        if (this.select) {
            return this.select.options[this.select.selectedIndex].value;
        }
        return this.input.value;
    }

    doValidate() {
        let valid = true;

        if (this.props.required) {
            switch (this.props.type) {
                case 'select':
                    valid = this.state.isSelected !== false;
                    break;
                case 'amount':
                    break;
                default:
                    valid = this.input.value !== '';
                    break;
            }
        }

        if (valid) {
            switch (this.props.type) {
                case 'email':
                    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    valid = re.test(this.input.value);
                    break;
                default:
                    break;
            }
        }

        this.setError(!valid);

        return valid;
    }

    setError(state) {
        this.setState({ error: state });
    }

    componentDidMount() {
        if (this.select) {
            if (this.props.value || this.props.defaultValue) {
                this.onChangeSelect();
            } else {
                this.select.selectedIndex = -1;
            }
        }
    }

    onChangeInput() {
        this.setState({
            isEmpty: this.input.value === '',
        });
        this.doValidate();
        this.props.onChange(this.input.value);
    }

    onChangeSelect() {
        const newSelected = this.select.selectedIndex !== -1;
        if (this.state.isSelected !== newSelected) {
            this.setState({
                isSelected: newSelected,
            });
        }

        setTimeout(() => {
            this.doValidate();
        }, 100);
        this.props.onChange();
    }

    onChangeAmount(value) {
        const state = {};
        const isNumber = typeof value === 'number';
        let val = isNumber ? value : this.amountInput.value * 1;
        if (val < this.amountMin) {
            if (isNumber) {
                val = this.amountMin;
            } else {
                state.error = true;
            }
        } else if (val > this.amountMax) {
            if (isNumber) {
                val = this.amountMax;
            }
        } else {
            state.error = false;
        }
        this.amountInput.value = val;
        state.amount = val;
        state.amountFormated = formatAmount(val);
        this.setState(state);
        this.props.onChange(val);
    }

    onBlurAmount() {
        const state = {
            error: false,
        };
        let val = Math.floor(this.amountInput.value * 1);
        if (val < this.amountMin) {
            val = this.amountMin;
        } else if (val > this.amountMax) {
            val = this.amountMax;
        }
        this.amountInput.value = val;
        state.amount = val;
        state.amountFormated = formatAmount(val);
        this.setState(state);
    }

    onDecreaseAmount(e) {
        e.preventDefault();
        let val = this.state.amount - this.DEFAULT_AMOUNT_STEP;
        this.onChangeAmount(val * 1);
    }

    onIncreaseAmount(e) {
        e.preventDefault();
        const val = this.state.amount + this.DEFAULT_AMOUNT_STEP;
        this.onChangeAmount(val * 1);
    }

    render() {
        const {
            children,
            type,
            name,
            value,
            defaultValue,
            label,
            placeholder,
            className,
            required,
            hidden,
        } = this.props;
        const hasLabel = !!label;
        const params = {
            type: type,
            name: name,
        };
        let output = null;
        let control = null;
        let elUnderline = <div className="form-control__underline" />;
        let elError = (
            <div className="form-control__error">
                <Isvg src="/svg/icon-attantion.svg" />
                <span className="form-control__error--invalid">
                    <LocaleText textKey="checkout.error_message.invalid" />
                </span>
                <span className="form-control__error--empty">
                    <LocaleText textKey="checkout.error_message.missing" />
                </span>
            </div>
        );

        if (value && `${value}` !== '') {
            params.value = value;
        }

        if (defaultValue && `${defaultValue}` !== '') {
            params.defaultValue = defaultValue;
        }

        if (required) {
            params.required = true;
        }

        if (placeholder && !hasLabel) {
            params.placeholder = placeholder;
        }

        switch (type) {
            case 'select':
                control = (
                    <select
                        {...params}
                        className={this.state.isSelected ? '' : 'is-empty'}
                        onChange={this.onChangeSelect}
                        ref={ref => {
                            this.select = ref;
                        }}
                    >
                        {children}
                    </select>
                );
                break;

            case 'textarea':
                if (!(value || defaultValue)) {
                    params.defaultValue = this.state.textareaValue;
                }
                control = <textarea {...params} maxLength={this.props.maxlength} />;
                elUnderline = null;
                break;

            case 'checkbox':
                control = (
                    <label>
                        <input {...params} />
                        <div>{children}</div>
                        <Isvg src="/svg/icon-check-small.svg" className="icon-checkbox" />
                    </label>
                );
                elUnderline = null;
                break;

            case 'amount':
                elUnderline = null;
                elError = null;
                params.type = 'number';
                params.className = 'amount--input';
                control = (
                    <span>
                        <div className="amount">
                            <button
                                type="button"
                                className="amount__decrease"
                                onClick={this.onDecreaseAmount}
                            />
                            <span className="amount__inner">
                                <input
                                    {...params}
                                    defaultValue={this.state.amount}
                                    onChange={this.onChangeAmount}
                                    onBlur={this.onBlurAmount}
                                    ref={ref => {
                                        this.amountInput = ref;
                                    }}
                                />
                                <div className="amount__formated">{this.state.amountFormated}</div>
                            </span>
                            <button
                                type="button"
                                className="amount__increase"
                                onClick={this.onIncreaseAmount}
                            />
                        </div>
                        <div className="amount__status">
                            <Isvg className="is-error" src="/svg/icon-attantion.svg" />
                            <Isvg src="/svg/icon-check-small.svg" />
                            {this.props.status}
                        </div>
                    </span>
                );
                break;

            default:
                control = (
                    <input
                        {...params}
                        className={this.state.isEmpty ? 'is-empty' : ''}
                        onChange={this.onChangeInput}
                        maxLength={this.props.maxlength}
                        ref={ref => {
                            this.input = ref;
                        }}
                    />
                );
        }

        if (!hidden) {
            output = (
                <div
                    className={`form-control form-control__${type}${
                        className ? ` ${className}` : ''
                    }${hasLabel ? ' is-labeled' : ''}${this.state.error ? ' is-error' : ''}`}
                >
                    {control}
                    {type === 'select' && (
                        <Isvg src="/svg/arrow-down.svg" className="form-control__arrow" />
                    )}
                    {label && (
                        <div className="form-control__label">
                            <div>
                                {label}
                                {required && <span>{' *'}</span>}
                            </div>
                        </div>
                    )}
                    {elUnderline}
                    {elError}
                </div>
            );
        }

        return output;
    }
}

FormControl.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    maxlength: PropTypes.number,
    onChange: PropTypes.func
};

FormControl.defaultProps = {
    onChange: () => {},
};

export default FormControl;
